import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

const SKCreator = () => {
  const { t } = useTranslation();
  
  return (
    <div>
    <Typography variant="h4" gutterBottom>{t('sk')}</Typography>
    </div>
  );
};

export default SKCreator;